import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];
import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import Icon from '../../../Icon';
import icons from '../../../Icon/icons';
import Text from '../Text';
import withMemo from '../../../../decorators/withMemo';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Password = function Password(props) {
  var classes = useStyles(props);
  var name = props.name,
    others = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    display = _React$useState2[0],
    setDisplay = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Text, _extends({}, others, {
    name: name,
    type: display ? 'text' : 'password',
    endOrnament: /*#__PURE__*/React.createElement(Icon, {
      icon: icons.Eye,
      onClick: function onClick() {
        return setDisplay(!display);
      },
      className: cx(classes.icon, display ? classes.iconOff : classes.iconOn)
    })
  }));
};
Password.styles = styles;
Password.propTypes = Text.propTypes;
Password.defaultProps = Text.defaultProps;
export default withMemo()(Password);